import $ from 'jquery';

export default (container = document) => {
  $('[data-rte-split-caption]:not([data-product])', container).each((i, caption) => {
    const $caption = $(caption);
    const img_src = $caption.data('imgSrc');
    const img_position = $caption.data('imgPosition');
    const content = $caption.html();
    const shoppable_items = $caption.data('shoppable');
    let shoppable_data = '';

    if (shoppable_items) {
      shoppable_data = `data-shoppable="${shoppable_items}"`;
    }

    let ordered_content;
    const image_panel = `
      <div class="Caption__panel Caption__image--wrapped AnimateOnLoad Animate--slide-up">
        <div class="Caption__image-container">
          <img onload="elementLoaded(this);" src="${img_src}" ${shoppable_data}>
        </div>
        <div class="SizingContent" aria-hidden="true" data-prevent-tab>
          <img class="SizingContent" src="${img_src}">
        </div>
      </div>
      `;

    const content_panel = `
      <div class="Caption__panel Animate Animate--slide-up">
        <div class="Caption__content Caption__content--full">${content}</div>
        <div class="Caption__content Caption__content--full SizingContent" aria-hidden="true" data-prevent-tab>${content}</div>
      </div>
    `;

    if (img_position === 'left') {
      ordered_content = `${image_panel}${content_panel}`;
    } else {
      ordered_content = `${content_panel}${image_panel}`;
    }

    const newHTML = `
    <section class="Section Section--fixed Section--mobile-full">
      <div class="Section__container">
        <div class="Caption RteSplitCaption">
          ${ordered_content}
        </div>
      </div>
    </section>
    `;

    $caption.replaceWith(newHTML);
  });
};